var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"fnt"},[_c('el-row',[_c('el-col',{staticClass:"hidden-xs-only",attrs:{"span":3}},[_c('span',[_vm._v("heherongzi.com ")])]),_c('el-col',{attrs:{"span":21}},[_c('span',[_vm._v("上海记算企业服务有限公司")])])],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }